import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { BookOpen, LayoutDashboard, LogOut, Store } from 'lucide-react';
import { Logo } from '../../components/Logo';
import { LanguageToggle } from '../../components/LanguageToggle';
import { Button } from '../../components/ui/button';
import { RemoveCookie, send, TOKEN_NAME } from '../../components';
import { useAuth } from '../../contexts/AuthContext';
import { isPartnerUser } from '../../lib/authRoutes';

const navItems = [
  { to: '/partner/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/partner/merchants', label: 'Merchants', icon: Store },
  { to: '/partner/docs', label: 'API Docs', icon: BookOpen },
];

export const PartnerShell = ({ children }) => {
  const { user, setAuth } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  if (!isPartnerUser(user)) {
    return <Navigate to="/" replace />;
  }

  const handleLogout = async () => {
    await send('io0013', {});
    RemoveCookie(TOKEN_NAME);
    sessionStorage.clear();
    localStorage.clear();
    setAuth({});
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 border-b border-border bg-white">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <Logo size="md" />
          <div className="flex items-center gap-2">
            <LanguageToggle />
            <Button variant="ghost" size="sm" onClick={handleLogout}>
              <LogOut className="h-4 w-4 md:mr-2" />
              <span className="hidden md:inline">Logout</span>
            </Button>
          </div>
        </div>
      </header>

      <div className="mx-auto grid max-w-7xl gap-6 px-4 py-6 sm:px-6 lg:grid-cols-[220px_1fr] lg:px-8">
        <nav className="flex gap-2 overflow-x-auto lg:flex-col lg:overflow-visible">
          {navItems.map((item) => {
            const active = location.pathname === item.to;
            const Icon = item.icon;

            return (
              <Link
                key={item.to}
                to={item.to}
                className={`inline-flex min-h-10 items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  active
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                }`}
              >
                <Icon className="h-4 w-4" />
                {item.label}
              </Link>
            );
          })}
        </nav>

        <main className="min-w-0">{children}</main>
      </div>
    </div>
  );
};
